var _rect, _rect2, _path, _path2;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBankInfoIcon = function SvgBankInfoIcon(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 20,
    height: 20,
    rx: 6,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 20,
    height: 20,
    rx: 6,
    stroke: "#7154D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9992 6.9984C10.8612 6.9984 10.7491 7.11044 10.7501 7.2485C10.7501 7.38656 10.8622 7.4986 11.0002 7.4986C11.1383 7.4986 11.2503 7.38656 11.2503 7.2485C11.2503 7.11044 11.1383 6.9984 10.9992 6.9984",
    stroke: "#7154D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2504 15.1858V10.4338H10.25",
    stroke: "#7154D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBankInfoIcon, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMSIgeT0iMSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iNiIgZmlsbD0id2hpdGUiLz4KPHJlY3QgeD0iMSIgeT0iMSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iNiIgc3Ryb2tlPSIjNzE1NEQ2Ii8+CjxwYXRoIGQ9Ik0xMC45OTkyIDYuOTk4NEMxMC44NjEyIDYuOTk4NCAxMC43NDkxIDcuMTEwNDQgMTAuNzUwMSA3LjI0ODVDMTAuNzUwMSA3LjM4NjU2IDEwLjg2MjIgNy40OTg2IDExLjAwMDIgNy40OTg2QzExLjEzODMgNy40OTg2IDExLjI1MDMgNy4zODY1NiAxMS4yNTAzIDcuMjQ4NUMxMS4yNTAzIDcuMTEwNDQgMTEuMTM4MyA2Ljk5ODQgMTAuOTk5MiA2Ljk5ODQiIHN0cm9rZT0iIzcxNTRENiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTEuMjUwNCAxNS4xODU4VjEwLjQzMzhIMTAuMjUiIHN0cm9rZT0iIzcxNTRENiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };